import React from 'react';

import { formatDate } from 'helpers/formatDate';

import { Loading } from 'components/shared/Loading';
import { Button } from 'components/shared/Button';
import { Icon } from 'components/shared/Icon';
import { Table } from 'components/shared/Table';

import { MenuLayout } from 'components/Layout';
import { EmptyState } from 'components/EmptyState';
import { ListToolbar } from 'components/Toolbar';
import { TablePagination } from 'components/TablePagination';

import { columns } from './LessonCategoriesPage.tableConfig';

import styles from './LessonCategoriesPage.module.scss';

const cellRenderer = (
  {
    item,
    key,
    minWidth,
    maxWidth,
  }: { item: any; key: any; minWidth: any; maxWidth: any },
  DefaultCell: any,
) => {
  switch (key) {
    case 'createdAt': {
      return (
        <DefaultCell key={key} style={{ minWidth, maxWidth }}>
          {formatDate(item[key], 'dd MMM, yyyy')}
        </DefaultCell>
      );
    }
    default: {
      return (
        <DefaultCell key={key} minWidth={minWidth} maxWidth={maxWidth}>
          {item[key] || '-'}
        </DefaultCell>
      );
    }
  }
};

const LessonCategoriesPage = ({
  loading,
  categories,
  currentPage,
  totalPages,
  perPage,
  sortParams,
  onSortChange,
  onPerPageChange,
  onNextPageClick,
  onPrevPageClick,
  onCategoryRowClick,
  onCategoryCreateClick,
  onCategoryRemoveClick,
  onCategoryEditClick,
}: {
  loading: any;
  categories: any;
  currentPage: any;
  totalPages: any;
  perPage: any;
  sortParams: any;
  onSortChange: any;
  onPerPageChange: any;
  onNextPageClick: any;
  onPrevPageClick: any;
  onCategoryRowClick: any;
  onCategoryCreateClick: any;
  onCategoryRemoveClick: any;
  onCategoryEditClick: any;
}) => {
  return (
    <MenuLayout>
      <ListToolbar
        title="Lesson categories"
        actionComponent={
          <Button
            size="md"
            variant="link"
            startIcon={<Icon name="plusRound" />}
            onClick={onCategoryCreateClick}
          >
            Create category
          </Button>
        }
      />
      {loading ? (
        <Loading />
      ) : (
        <>
          {categories.length ? (
            <div className={styles.inner}>
              <Table
                columns={columns}
                params={sortParams}
                actions={[
                  {
                    key: 'edit',
                    icon: 'edit',
                    tooltipText: 'Edit category',
                    onClick: onCategoryEditClick,
                  },
                  {
                    key: 'remove',
                    icon: 'trash',
                    tooltipText: 'Remove category',
                    onClick: onCategoryRemoveClick,
                  },
                ]}
                data={categories}
                cellRenderer={(props: any, DefaultCell: any) =>
                  cellRenderer(props, DefaultCell)
                }
                onRowClick={(category: any) => onCategoryRowClick(category.id)}
                onSortChange={onSortChange}
              />
              <TablePagination
                currentPage={currentPage}
                perPage={perPage}
                totalPages={totalPages}
                onPerPageChange={onPerPageChange}
                onNextPageClick={onNextPageClick}
                onPrevPageClick={onPrevPageClick}
              />
            </div>
          ) : (
            <EmptyState
              className={styles.emptyState}
              icon="courses"
              title="Add a category"
              text="No categories - yet! Looks like you haven't created a category. Add a new category in the top right corner"
            />
          )}
        </>
      )}
    </MenuLayout>
  );
};

export default React.memo(LessonCategoriesPage) as any;
